import React from 'react'
import classnames from 'classnames'
import { format } from 'date-fns'
import {useHistory, useParams} from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import {
  Avatar,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Button,
  Chip,
} from '@material-ui/core'

import config from 'config'

import getGinState from '../../utils/getGinState'
import getCartState from '../../utils/getCartState'

import {
  PRODUCTION_STATUS_NO_LABEL,
  PRODUCTION_STATUS_SHIPPED,
  PRODUCTION_STATUS_TO_DO,
  PRODUCTION_STATUS_DONE,
  PRODUCTION_STATUS_TO_VERIFY,
  ProductionStatusLabel,
  CART_STATE_PAID,
} from '../../constants'

import OrderWidgetActions from './OrderWidgetActions'

const bottlePng =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAdVBMVEX///8AAACenp7w8PB9fX1zc3PExMTV1dXPz8+1tbXd3d1gYGC7u7sdHR38/PxWVlbIyMgTExPz8/Po6Oipqak4ODiVlZVqamqwsLDq6uqjo6MmJiZAQECEhISMjIxOTk4vLy9kZGQYGBhRUVE+Pj4sLCwiIiK6lwyAAAAGGklEQVR4nO2d2WKqMBBAWQQr7iutWqt2+f9PvNZMBDUbxJhJ75w3CqRzFCFkmUSRA/IybkOZuwjGBVkrv186vkM3Y9VaMI7XvoM3YWYhGMcj3+EbMLAyfPEdvgE9K8Oe7/ANAMOy04wyOMN5w9PmwRkWDU8ryBAPZCiBDBFBhhLIEBFkKIEMEUGGEsgQEWQogQwRQYYSyBARYDjoNmMQnGFLQjC0a/Me+A7fgLmV4Zvv8E3oWwgefAdvhE3n08x38GbM2n6L/UAET8wTFvJuwGBb4xw28zH7A2zu2FYSxG+Q02VBT2CTbWWX3dAPDlsTttV9epQ2vLCg+dADtWHOtkLoHK0gQzLEDxmSIX7IkAzxQ4ZkiB8yJEP8kCEZ4ocMyRA/ZEiG+CFDMsQPGZIhfv6+YbeFIe4e0mKRLafxHY0M60yX2aLp/D6X5Nv7GO0Mz2yxzF5PPyQR2hrG8Wf6dBsB8vjsDauxDh5RDmPj40fUhm+qIrxfqV1VdCt+lNow2qkKaTpQ9cGMqkj24/41WfXxawyjvLw5d7yvCn6q0B0dHsZOeU/QGQpI33nR7w+KtRV8pOVQ8+xqYXgqnD9gfd5Q4XM+6rJZtDK8DHJcaY5zCYSgrW+1M+QD3oaWUVoA4+v72gNbGkZQl/A3aJEPy9ce2NbwlR3n77GfmH7EbQ3hIllYRWlDYnqva2uYsuMSqyhtIMML/4vhZszZ/FHDO7TnhWO4FAouteeFYyhO4aYPPBzDkUhwqs/NFo5h9Z5QMTQ4LSDDaJR8HYcVx+3aJLteSIbtIEPnkKE1ZOgcMrxh1Ft1DuPyffVq2pEWmOHVJO+PxKTzLDDD2+r3h775JSxDwRTvL51jWIbCl8Sx+tzADDsiRXVTZGCGZ8XhfnPzmqFqsw/NMJql5xeKdLKq33Uy+QnBGdZ4q732l9KjQjY8Pf+rnt+d7JiwDaOo+OGKsrw72A0niW6YwYErSio4yA1/03ssNW0VfKEIScMibsOV+icG8LU+xN1LqA1nyi+ngj83hF82akPo4tf2D4OE+MGP2hAC1w9pWsCRon2YDaF/emtQClynogoqZsNPtsukB34gv54RG8J95tuomKn0XoPYcNAktJ30+8ZiKMhBBkGbjSvsSu+mMySGvfyWydd5x9SsGOh7207uyukhMZQyNixHNkycg9fQdNykbhkzvIama4zp1jEL33BNhk4tVOgMTSN7VDmPByKb3Oc9ZjsUrWhXwJ3mvpgJEkPBE59VxD4My2EDZY/3O7A88QW1NkhQaraaITzxBVVvLLU2gSHc/836CWGyoqDWhtgQfkC6VhoGNAcIZlgiNuTDvIyKiaWXNGLD6MB2maRYh+YAUds+ZkN4QdwYlDJkh4padDAb8ktPP98FbkrCNy3UhryeonsJhgkH4iZh1Ib8XvOjLmI0VXyFuA0vq0CoKzb85Vfc2Y3bkE9aUipyQUlrAHJD3l4fb2Xdb+mls1uSUB+5YW2Otrhtv5okLUsYgd2w9t7Xv+8CLT4ve19lBaA3rE/SLq8bfPNDtUsugN/wuo3psHhJ01n69rK4WgBDMfcuAENe6VSgGhQVgmFUCFKe1PhWTs8MwlCdMUETeyCG0byU+HV0Z4ZieHIUjUtUp2E4E47hqYY9ef+p2e13RlmhQjI8UwzWySpZ58bpSoIzbAwZOocMrSFD55ChNX/fEFpdpW/IznFvyN4vzTrpXODe8Ffx0+O6iE8w9AwZhg8Zhg8Zhg8Zhg8Zhg8Zhs8TDIts7C/z5TMMzx3lppMaHODe8Hj+B94ztFI7TXvI0DlkaA0ZOocMrSFD55ChNWToHDK0hgydQ4bWkKFzyNAaMnQOGVpDhs4hQ2vI0DlkaA0ZOufvG0J+J3dLhMNyCqb5ph4PTFXWr2GJ9h/oMF6HtC191xeJFhaAs4Wl+ZLYjoo3AbIDbdwMNR+xXnyvizrzxCR7F7fTFNaB9HmRVum4H3+7G13SFZhmfXNDbWmVbdZ5HFkt4ae/2RZnqtwXrvA3mAZY6GO0wt+MoAs9fZQW+HvY1yj2zvyWXm+jNV7dOH6ZZHt7FsWi3OhDbsB3tnhQTekf9wdJYhaPwpMAAAAASUVORK5CYII='

const useStyles = makeStyles((theme) => ({
  card: {
    minWidth: 900,
    display: 'flex',
    marginBottom: theme.spacing(2),
    height: 171,
  },
  details: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
  },
  content: {
    width: '100%',
    marginLeft: theme.spacing(2),
  },
  cover: {
    width: 171,
    minWidth: 171,
    height: 171,
  },
  botanies: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: 300,
    paddingRight: 10,
  },
  col1: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 155,
    minWidth: 300,
  },
  bottleCard: {
    display: 'flex',
    alignItems: 'center',
    width: 70,
    height: 50,
    backgroundColor: '#f6f6f6',
    marginRight: 10,
    marginBottom: 10,
  },
  botanyCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 70,
    height: 70,
    marginRight: 10,
    marginBottom: 10,
  },
  botanyAvatar: {
    width: 25,
    height: 25,
    margin: 5,
  },
  bottleAvatar: {
    margin: 5,
  },
  gridRoot: {
    width: '100%',
    flexGrow: 1,
  },
  productionState: {
    marginTop: 10,
    color: 'white',
    fontWeight: 600,
    width: '100%',
    '&.toVerify': {
      backgroundColor: 'lightBlue',
    },
    '&.missingLabel': {
      backgroundColor: 'red',
    },
    '&.toDo': {
      backgroundColor: 'orange',
    },
    '&.done': {
      backgroundColor: 'saddlebrown',
    },
    '&.sent': {
      backgroundColor: 'green',
    },
  },
}))

const Botany = ({ botany }) => {
  const classes = useStyles()

  return (
    <Card className={classes.botanyCard}>
      <Avatar
        alt={botany.name}
        src={`${config.assetsPublicBaseUrl}images/botaniche/${botany.image}.jpg`}
        className={classes.botanyAvatar}
      />
      <Typography variant="body2">{botany.name.substr(0, 8)}</Typography>
      <Typography variant="body2" color="textSecondary">
        {botany.intensity}
      </Typography>
    </Card>
  )
}

const Bottles = ({ number }) => {
  const classes = useStyles()

  return (
    <Card className={classes.bottleCard}>
      <Avatar
        alt="Remy Sharp"
        src={bottlePng}
        className={classes.bottleAvatar}
      />
      <Typography variant="body2" color="textSecondary">
        {number}
      </Typography>
    </Card>
  )
}

const ProductionStatusClasses = {
  [PRODUCTION_STATUS_TO_VERIFY]: 'toVerify',
  [PRODUCTION_STATUS_NO_LABEL]: 'missingLabel',
  [PRODUCTION_STATUS_TO_DO]: 'toDo',
  [PRODUCTION_STATUS_DONE]: 'done',
  [PRODUCTION_STATUS_SHIPPED]: 'sent',
}

const ProductionStatus = ({ order }) => {
  const classes = useStyles()
  const ginState = getGinState(order)
  return (
    <Chip
      className={classnames(classes.productionState, [
        ProductionStatusClasses[ginState],
      ])}
      label={ProductionStatusLabel[ginState]}
    />
  )
}

const OrderWidget = ({
  order,
  productionStatusFilters = [],
  setOrder,
  hideActions,
}) => {
  const params = useParams()
  const area = params.area
  const classes = useStyles()
  const history = useHistory()

  const cartState = getCartState(order)
  return (
    <Card className={classes.card}>
      <CardMedia className={classes.cover} image={order.labelImage} title="" />
      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Grid container className={classes.gridRoot} spacing={8}>
            <Grid item xs={4}>
              <div className={classes.col1}>
                <div>
                  {order.paymentDate && (
                    <Typography gutterBottom>
                      Del {format(new Date(order.paymentDate), 'dd MMM, HH:mm')}
                    </Typography>
                  )}
                  {productionStatusFilters.includes(-10) && (
                    <Typography gutterBottom>
                      Del{' '}
                      {format(new Date(order.checkedOutDate), 'dd MMM, HH:mm')}
                    </Typography>
                  )}
                  <Typography variant="h3" color="textSecondary" gutterBottom>
                    {order.ginName}
                  </Typography>
                </div>
                <div>
                  <Bottles number={order.quantity} />
                </div>
              </div>
            </Grid>
            <Grid item xs={4}>
              <Box className={classes.botanies}>
                {order.recipe.botanics.map((botany) => (
                  <Botany key={botany.id} botany={botany} />
                ))}
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box display="flex">
                <Box pb={'2px'} pr={'2px'} width={130}>
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => history.push(`/${area}/orders/${order.ginId}`)}
                  >
                    {' '}
                    Visualizza
                  </Button>
                </Box>
                <Box width={130}>
                  <Button
                    fullWidth
                    variant="outlined"
                    className={classes.button}
                    href={order.labelImage}
                    download={`${order.name}.png`}
                    target="_new"
                  >
                    Etichetta
                  </Button>
                  {cartState === CART_STATE_PAID && (
                    <ProductionStatus order={order} />
                  )}
                </Box>
              </Box>
              {!hideActions && <OrderWidgetActions order={order} setOrder={setOrder} />}
            </Grid>
          </Grid>
        </CardContent>
      </div>
    </Card>
  )
}

export default OrderWidget
